import React from 'react';
import { useAtom } from 'jotai';
import { Tooltip } from '@mui/material';
import PageWrapper from '../../Components/Paper/PageWrapper';
import CustomFilters from './Components/CustomFilters';
import { searchValuesAtom } from '../../Atoms';
import { DEFAULT_STATS_TABS } from '../../Utils/constants/general';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';

const columns = [
  {
    id: 'otherSections',
    noCaption: true,
    size: { md: 0.3 },
    formatCallback: (value) =>
      value ? (
        <Tooltip
          title={
            <ul>
              {value.split(',').map((el) => (
                <li key={el} style={{ fontSize: '1rem' }}>
                  {el}
                </li>
              ))}
            </ul>
          }
          placement="top"
          arrow
        >
          <PlaylistAddCheckOutlinedIcon sx={{ opacity: 0.6 }} />
        </Tooltip>
      ) : (
        <div />
      ),
  },
  {
    id: 'fullName',
    label: 'NAME',
    noCaption: true,
    size: { md: 3 },
  },
  {
    id: 'tag',
    label: 'OFFER',
  },
  {
    id: 'dealer',
    size: { md: 3 },
  },
  {
    id: 'liquidationDate',
  },
  {
    id: 'remainingDays',
    label: 'REMAINING_DAYS',
    formatCallback: (value) => (value === 0 ? '0' : value),
  },
];
const WELCOME_SORTING = [
  {
    label: 'INSERTING_DATE',
    value: 'createdOn',
    isDefault: true,
  },
  {
    label: 'NAME',
    value: 'fullName',
  },
  { label: 'FISCALCODE', value: 'fiscalCode' },
];

const WelcomeCallsPage = function WelcomeCallsPage(props) {
  const [searchValues, setSearchValues] = useAtom(searchValuesAtom);

  const getRowSx = (rowData) =>
    !rowData?.remainingDays
      ? {
          color: '#d32f2f',
          border: '2px solid #d32f2f',
          backgroundColor: 'rgba(255, 0, 0, 0.08) !important',
          '& .MuiTypography-root': {
            color: '#d32f2f !important',
          },
        }
      : {};

  const handleChangeSearchValues = (valueObj) => {
    setSearchValues((old) => ({
      ...old,
      ...valueObj,
    }));
  };

  return (
    <PageWrapper
      statsTabs={DEFAULT_STATS_TABS}
      period=""
      apiType="Welcome"
      columns={columns}
      customFilters={
        <CustomFilters
          defaultValues={searchValues}
          onConfirm={handleChangeSearchValues}
        />
      }
      sortingOptions={WELCOME_SORTING}
      searchBoxFilters={['fullNameSearch', 'fiscalCode', 'practiceNumber']}
      standardFilters={[
        { keyName: 'lastCallInCurrentMonth', operator: 'eq' },
        { keyName: 'dealer', operator: 'eq' },
        { keyName: 'tag', operator: 'eq' },
        { keyName: 'liquidationDate', operator: 'eq' },
      ]}
      rangeFilters={[]}
      rowSxCallback={getRowSx}
      {...props}
    />
  );
};

export default WelcomeCallsPage;
